import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { StoreManagementDeliveryStoreService } from '@/services/StoreManagement/DeliveryStores/StoreManagementDeliveryStoreService';
import { LinkedStatus } from '@/services/StoreManagement/MasterStores/hooks/show/useStoreManagementMasterStoreShow';

export type StoreManagementDeliveryStoreUpdateLinkedStatusParams = {
  linked_status: LinkedStatus;
};

export const useStoreManagementDeliveryStoreUpdateLinkedStatus = async (
  id: string,
  params: StoreManagementDeliveryStoreUpdateLinkedStatusParams
): Promise<void> => {
  const storeManagementDeliveryStoreService =
    new StoreManagementDeliveryStoreService(getClient());
  try {
    return await storeManagementDeliveryStoreService.updateLinkedStatus(
      id,
      params
    );
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
